// @ts-nocheck

class CrossSellingCollections {
  static #STORAGE_KEY = 'crossSellingCollections';
  static #MAX_TRACKED_COLLECTIONS = 4;

  static #mutationObserver = null;
  static #hasConsent = null;

  static async startTrackingWithConsent() {
    // let start = performance.now();

    document.addEventListener('visitorConsentCollected', (event) => {
      this.#hasConsent = detail?.preferencesAllowed;
      this.tryTrackCollection();
    });

    await this.loadConsentAsync();

    // console.log(`Cross selling rendered after ${performance.now() - start} ms.`);

    this.tryTrackCollection();
  }

  static tryTrackCollection() {
    if (!this.#hasConsent) {
      this.clearTracking();
      return;
    }

    const currentCollectionData = this.getCurrentCollectionData();
    if (!currentCollectionData) {
      return;
    }

    let trackedCollections = this.getTrackedCollections();

    trackedCollections = trackedCollections.filter((_) => _?.id && _.id !== currentCollectionData.id);
    trackedCollections.unshift(currentCollectionData);
    trackedCollections = trackedCollections.slice(0, this.#MAX_TRACKED_COLLECTIONS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(trackedCollections));
  }

  static clearTracking() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  static getTrackedCollections() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  static loadConsentAsync() {
    return new Promise((resolve) => {
      // this.#hasConsent = window.Shopify.customerPrivacy?.preferencesProcessingAllowed();
      // resolve(this.#hasConsent);
      // return;

      if (this.#hasConsent !== null) {
        return;
      }

      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        (error) => {
          if (error) {
            return;
          }

          this.#hasConsent = window.Shopify.customerPrivacy?.preferencesProcessingAllowed();
          resolve(this.#hasConsent);
        },
      );
    });
  }

  static getCurrentCollectionData() {
    const datas = this.loadConfigurationFromLiquid('#current-collection-data');
    if (!datas) {
      return null;
    }

    return datas[0];
  }

  static getCrossSellingCollectionsConfigurations() {
    return this.loadConfigurationFromLiquid('.cross-selling-collections-configuration');
  }

  static loadConfigurationFromLiquid(querySelector) {
    const jsonElements = document.querySelectorAll(querySelector);

    if (!jsonElements) {
      return null;
    }

    return [...jsonElements]
      .map((jsonElement) => {
        const json = jsonElement?.text;

        if (!json) {
          return null;
        }

        try {
          return JSON.parse(json);
        } catch (error) {
          console.warn('Could not load current collection data.');
          console.warn(json);
          console.warn(error);
          return null;
        }
      })
      .filter((_) => _);
  }

  static renderCrossSelling() {
    if (!this.#mutationObserver) {
      const mutationCallback = async (mutationList, observer) => {
        this.renderCrossSelling();
      };

      const mutationObserver = (this.#mutationObserver = new MutationObserver(mutationCallback));
      mutationObserver.observe(document, { childList: true, subtree: true });

      return;
    }

    try {
      const urlParameters = new URLSearchParams(window.location.search);

      for (let parameter of urlParameters.entries()) {
        const key = parameter[0];

        if (key.startsWith('filter')) {
          return;
        }

        const value = parameter[1];

        if (key === 'page') {
          const currentPage = value;
          if (!(!currentPage || currentPage == '1')) {
            return;
          }
        }
      }

      const currentCollectionData = this.getCurrentCollectionData();
      const configurations = this.getCrossSellingCollectionsConfigurations();

      if (!configurations) {
        return;
      }

      const trackedCollections = this.getTrackedCollections();

      for (let configuration of configurations) {
        const grid = document.querySelector(`.product-grid--${configuration.sectionId}`);

        if (!grid) {
          console.warn(`No grid found for section ID ${configuration.sectionId}`);
          continue;
        }

        if (grid.hasAttribute('cross-selling-rendered')) {
          return;
        }

        grid.setAttribute('cross-selling-rendered', '');

        const gap = grid.querySelector('.product-card__content')?.style.getPropertyValue('--product-card-gap');

        const gallery = grid.querySelector('.card-gallery');
        if (!gallery) {
          continue;
        }

        const galleryAspectRation = gallery.style.getPropertyValue('--gallery-aspect-ratio');
        const productMediaAspectRatio = gallery.querySelector('.product-media')?.style.getPropertyValue('--ratio');

        const collectionsToRender = configuration.defaultCollections?.filter((_) => _.id) ?? [];

        if (configuration.enableDynamicCrossSelling && configuration.collectionId === currentCollectionData.id && trackedCollections) {
          for (let trackedCollection of trackedCollections) {
            if (trackedCollection.id === currentCollectionData.id) {
              continue;
            }

            collectionsToRender.unshift(trackedCollection);
          }
        }

        const positions = configuration.renderPositions
          .split(' ')
          .map((_) => parseInt(_))
          .filter((_) => _ || _ === 0);

        for (let [index, position] of positions.entries()) {
          const collection = collectionsToRender[index];
          if (!collection) {
            console.warn(`No collection to render found with index ${index}`);
            continue;
          }

          var card = document.createElement('li');

          card.innerHTML = `
<div style="display: flex; flex-direction: column; justify-content: space-between; align-items: center; height: 100%;">

  <div style="display: flex; flex-direction: column; gap: ${gap};">
  
    <div class="product-media" style="--gallery-aspect-ratio: ${galleryAspectRation}; --ratio: ${productMediaAspectRatio}">
      <a href="${collection.url}" style="width: 100%;">
        <img src="${collection.imageUrl}" style="height: 100%; object-fit: contain;"/>
      </a>
    </div>
    
    <p class="spacing-style text-block h4 text-block--align-left">${collection.title}</p>

  </div>

    <a class="button" style="border-radius: ${configuration.buttonBorderRadius}px; --button-background-color: ${configuration.buttonBackgroundColor}; --button-color: ${configuration.buttonTextColor}; --button-border-color: ${configuration.buttonBackgroundColor}; background-color: ${configuration.buttonBackgroundColor}; color: ${configuration.buttonTextColor}; border-color: ${configuration.buttonBackgroundColor}" href="${collection.url}">${configuration.buttonText}</a>

</div>
    `;
          grid.insertBefore(card, grid.children[position - 1]);
        }
      }
    } catch (error) {
      console.warn(error);
    }
  }
}

CrossSellingCollections.renderCrossSelling();

document.addEventListener('DOMContentLoaded', (event) => {
  CrossSellingCollections.startTrackingWithConsent();
});
